import startsWith from "lodash/startsWith";
import { OBJECT_STORAGE_STATIC } from "../utils/images";

const aliases: Record<string, string> = {
  [OBJECT_STORAGE_STATIC]: "https://cdn.appcraft.events/events",
};

export function cdnify(url: string): string {
  for (const key of Object.keys(aliases)) {
    if (startsWith(url, key)) {
      return url.replace(key, aliases[key]);
    }
  }
  return url;
}
